import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { staffRemunerationOptions } from "./staffRemunerationOptions";
import { tabs } from "./staffRemunerationTabs";



export const fieldsQuery = "*.*";

export const staffRemunerationRoutes = [
    {
        path: "/staff_remuneration",
        element: (
            <Records entity="staff_remuneration" fieldsQuery={fieldsQuery} options={staffRemunerationOptions} heightOfHeaders={190} />
        ),
    },
    {
        path: "/staff_remuneration/:id",
        element: <Record entity="staff_remuneration" type="detail" fieldsQuery={fieldsQuery} body={<DetailTabs tabs={tabs} />} />,
        children: [
            {
                path: "/staff_remuneration/:id/detail",
                element: <Groups groupsOptions={staffRemunerationOptions?.groupsOptions} />,
            },
 

        ],
    },
    {
        path: "/staff_remuneration/:id/update",
        element: (
            <Record
                entity="staff_remuneration"
                type="update"
                body={<EntityForm groupsOptions={staffRemunerationOptions?.groupsOptions} />}
            />
        ),
    },
    {
        path: "/staff_remuneration/create",
        element: (
            <Record
                entity="staff_remuneration"
                type="create"
                body={<EntityForm groupsOptions={staffRemunerationOptions?.groupsOptions} />}
            />
        ),
    },
];
